import type { CompanyShellExtractionProvenance } from "./BulkCreateCompanyWizardContext";
import s from "./CompanyShellExtractionNotice.module.css";

interface CompanyShellExtractionNoticeProps {
  /** Null for a CSV batch, which needs no such warning. */
  provenance: CompanyShellExtractionProvenance | null;
}

/**
 * The "these values came from a document, check them" warning.
 *
 * Rendered wherever an extracted batch is reviewed rather than once at the
 * point of upload: the values are plausible enough to pass a read-through,
 * and the server validator cannot tell a wrong-but-well-formed company name
 * from a right one.
 */
export function CompanyShellExtractionNotice({
  provenance,
}: CompanyShellExtractionNoticeProps) {
  if (!provenance) return null;

  return (
    <section className={s.notice} aria-label="Extracted company details">
      <p className={s.warning} role="status">
        Company details were read from{" "}
        <strong>{provenance.sourceFileName}</strong> and may be incomplete or
        wrong. Check every field against the questionnaire before validating.
      </p>
      {provenance.missingColumns.length > 0 && (
        <p className={s.missingColumns}>
          No value was returned for: {provenance.missingColumns.join(", ")}.
        </p>
      )}
    </section>
  );
}
